export default class ServiceResponse {
    public success: boolean;
    public message: string;
    public respCode: number;
    public numeroSolicitud:number;
}